import React from 'react';
import ReactDOM from 'react-dom'; // Use ReactDOM for React 17
import App from './App';
import './index.css'; // Optional: If you have a CSS file for global styles

const root = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  root
); 